import { DateTime } from "luxon";
import { UI_TIMEZONE } from "@/configConstants";

export function toBerlinDateTimeFromISO(iso: string) {
	return DateTime.fromISO(iso, { zone: "utc" }).setZone(UI_TIMEZONE);
}

export function parseEventDate(dateStr: string) {
	// event.date is YYYY-MM-DD
	return DateTime.fromISO(dateStr, { zone: UI_TIMEZONE });
}

export function formatForDisplay(input: string | Date | DateTime, options: Intl.DateTimeFormatOptions = {}) {
	let dt: Date;
	if (typeof input === "string") {
		dt = toBerlinDateTimeFromISO(input).toJSDate();
	} else if (input instanceof Date) {
		dt = input;
	} else {
		dt = input.setZone(UI_TIMEZONE).toJSDate();
	}
	return new Intl.DateTimeFormat("de-DE", { ...options, timeZone: UI_TIMEZONE }).format(dt);
}

export function berlinStartOfDayFromISODate(dateStr: string) {
	return DateTime.fromISO(dateStr, { zone: UI_TIMEZONE }).startOf("day");
}

export function berlinTodayStart() {
	return DateTime.now().setZone(UI_TIMEZONE).startOf("day");
}
